<template>
    <van-popup v-model="isShow"
        :overlay="true"
        :closeable="true"
        :round="true"
        :close-on-click-overlay="false"
        :duration="0"
        @close="closeModal">
        <div class="community-user-limit-modal">
            <div class="popup-title">{{ popupTitle }}</div>
            <div class="community-live-code"
                @touchstart="communityScan">
                <img :src="liveCodeSrc"
                    alt="" />
            </div>
            <div class="community-live-code-tips">长按识别入群</div>
        </div>

    </van-popup>
</template>
<script>
import { Popup } from 'vant';
import { ActivityType } from '../../../../../commons/commonVariables.js';
export default {
  components: {
    [Popup.name]: Popup,
  },
  props: {
    /**
     * 活动类型
     */
    activityType: {
      type: String,
      default: '',
    },
    /**
     * 活动编码
     */
    activityCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isShow: false,
      liveCodeSrc: '', // 社群活码
      communityChannelCode: '', // 社群活码所在门店编码
    };
  },
  computed: {
    popupTitle() {
      let title = '';
      if (this.activityType === ActivityType.bigTurnable) {
        title = '您未加入会员群，暂无抽奖机会';
      } else if (this.activityType === ActivityType.thematicActivity) {
        title = '您未加入会员群，无法领取此奖品';
      }
      return title;
    },
  },
  methods: {
    openModal(liveCodeSrc, channelCode) {
      this.liveCodeSrc = liveCodeSrc || '';
      this.communityChannelCode = channelCode || '';
      this.isShow = true;
    },
    // 社群扫码上报
    communityScan() {
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: 'miniMemberAndCommunityStatistics/communityScan',
        params: {
          activityCode: this.activityCode,
          channel: '1', //渠道 1、活力魔方活动 2、门店WIFI 3、企业微信小程序 4、荣耀+app（店员开单） 5、门店扫描 6、微信小程序 7、支付宝小程序
          channelCode: this.communityChannelCode,
        },
        success: (r) => {
          console.log('识别社群二维码', r);
        },
      });
    },
    closeModal() {
      this.isShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.community-user-limit-modal {
  width: 85.3vw;
  padding: 30px 35px 40px;
  .popup-title {
    font-size: 15px;
    color: #000000;
    text-align: center;
    font-weight: 400;
  }
  .community-live-code {
    margin: 5vw auto;
    width: 35.2vw;
    height: 17.5vh;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .community-live-code-tips {
    font-size: 15px;
    color: #000000;
    text-align: center;
    font-weight: 400;
  }
}
/deep/ .van-popup--round {
  border-radius: 12px !important;
}

/deep/ .van-popup__close-icon {
  font-size: 20px !important;
  color: #999 !important;
}

/deep/ .van-popup__close-icon--top-right {
  top: 14px !important;
  right: 14px !important;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/communityUserLimitModal.vue